import { fetchUserAttributes } from "aws-amplify/auth";
import { useQuery } from "@tanstack/react-query";

export const userAttributesQueryKeys = {
  all: ["user-attributes"] as const,
};

export const userAttributesQueries = {
  detail: () => ({
    queryKey: userAttributesQueryKeys.all,
    queryFn: fetchUserAttributes,
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 30,
    retry: false,
  }),
};

export const useUserAttributes = (enabled = true) => {
  return useQuery({
    ...userAttributesQueries.detail(),
    enabled,
  });
};
